export default "__VITE_ASSET__Rl6xN3Gq__"